import { render } from "./SharesPage.vue?vue&type=template&id=71b3f4b0"
import script from "./SharesPage.vue?vue&type=script&lang=js"
export * from "./SharesPage.vue?vue&type=script&lang=js"

import "./SharesPage.vue?vue&type=style&index=0&id=71b3f4b0&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__